import { Injectable, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Apiservice } from './api.service';
//import { StringMap } from '../../../node_modulesXX/@angular/compiler/src/compiler_facade_interface';
import { AccountNoAuth } from './templates/AccountNoAuth';
import { AccountPermessi } from './templates/AccountPermessi';
import { utenti, utentiDiOwner } from './templates/utenti';
import { Utenteservice } from './utente.service';
//import { utenti } from './templates/utenti';
import { CarrCer } from './templates/CarrCer';
import { infoImpresa } from './templates/infoImpresa';
//import { listaCer } from './templates/listaCer';
import { autorizzazione } from './autorizzazione';
import { AlboAutomezzo } from './templates/AlboAutomezzo';
import { AlboCategoria } from './templates/AlboCategoria';
import { AutorizzazioneArea2 } from './templates/AutorizzazioneArea';
import { AutorizzazioneAreaCer, AutorizzazioneAreaCer2 } from './templates/AutorizzazioneAreaCer';
import { AutorizzazioneCer } from './templates/AutorizzazioneCer';
import { Azienda } from './templates/Azienda';
import { CarrMobili } from './templates/CarrMobili';
import { CausaleRifiutiBho } from './templates/CausaleRifiutiBho';
import { StatoEstero } from './templates/StatoEstero';
import { albo } from './templates/albo';
import { ateco } from './templates/ateco';
import { autista } from './templates/autista';
import { automezzi } from './templates/automezzi';
import { automezzo } from './templates/automezzo';
import { cantiere } from './templates/cantiere';
import { categoria } from './templates/categoria';
import { cer } from './templates/cer';
import { comuni } from './templates/comuni';
import { contatto } from './templates/contatto';
import { esportaSediFiltri, esportaUnitaLocaliFiltri } from './templates/esportaSediUnitaLocaliFiltri';
import { formulariFormDatiAccettazione } from './templates/formulariFormDatiAccettazione';
import { formulariFormDatiQuantita } from './templates/formulariFormDatiQuantita';
import { formulariFormDatiTrasportoQuantita } from './templates/formulariFormDatiTrasportoQuantita';
import { formularioForm } from './templates/formularioForm';
import { imballo, imballo2AleAnaColumn } from './templates/imballi';
import { licenze } from './templates/licenze';
import { magazzinoRifiuti } from './templates/magazzinoRifiuti';
import { magazzinorifiuticer } from './templates/magazzinorifiuticer';
import { onu } from './templates/onu';
import { posizioniRifiuto } from './templates/posizioniRifiuto';
import { produttori } from './templates/produttori';
import { provincia } from './templates/provincia';
import { renEsportazioni, renEsportazioniMovimenti, serviceRentriSede } from './templates/renEsportazioni';
import { sedeForm } from './templates/sedeForm';
import { serviceRentriRegistriElenco } from './templates/serviceRentriRegistriElenco';
import { smaltitori } from './templates/smaltitori';
import { soggetto, soggettoDetail } from './templates/soggetto';
import { datiInGrid, graficoCommento, messaggioSemplice, statisticheRifiutiGrafiche } from './templates/statisticheRifiutiGrafiche';
import { tipo } from './templates/tipo';
import { tipoAutorizzazione } from './templates/tipoAutorizzazione';
import { trasportatori } from './templates/trasportatori';
import { unitalocali } from './templates/unitalocali';
import { zona } from './templates/zona';

import { AlboCer } from './templates/AlboCer';
import { CausaleRifiuti, CausaleRifiutiVociObbligatori, CausaliAvanzate } from './templates/CausaleRifiuti';
import { ConfigurazionePosizioneCausaleRentri } from './templates/ConfigurazionePosizioneCausaleRentri';
import { ConfigurazioneRentri } from './templates/ConfigurazioneRentri';
import { Configurazioni, ConfigurazioniModuli, NewConfigurazioniModuli } from './templates/ConfigurazioniModuli';
import { ElencoFIRPerBlocco } from './templates/ElencoFIRPerBlocco';
import { PosizioneCausale } from './templates/PosizioneCausale';
import { VivifirBlocchi, ViviFirBlocchiAzienda, VivifirxFIRBlocchi } from './templates/ViviFirBlocchiAzienda';
import { ViviFirEditorFir } from './templates/ViviFirEditorFir';
import { esportaForm } from './templates/esportaForm';
import { formulariFormDatiTrasporto } from './templates/formulariFormDatiTrasporto';
import { gestioneAzienda, gestioneAziendaAdmin } from './templates/gestioneAzienda';
/* import { movimentiRifiutoOld, altriDatiMovimenti, datiTrasportoMovimento, altriItermediariMovimento, altriTrasportatoriMovimento, scaricoRifiuto,filtriScarico } from './templates/movimentiRifiuto-old'; */
import {
   altriDatiFormulario,
   altriDatiPesata,
   altriDatiRifiuto,
   elencocarichiAbbinati,
   FormulariDaMov,
   giacenzePanelMovimenti,
   grigliaMovimentiRegistro,
   listaSoggetti,
   movimentiRifiuto,
   RitiriGrid,
   scaricoRifiuto,
   tabellaScarichi,
} from './templates/movimentiRifiuto';

import { Column } from 'devextreme/ui/data_grid';
import { CobatCer } from './templates/CobatCer';
import { ElaboraStatistica } from './templates/ElaboraStatistica';
import { EditGruppo, Gruppo } from './templates/Gruppo';
import { RegistroRifiuti } from './templates/RegistroRifiuti';
import { ViviFirElencoFIRBlocchi } from './templates/ViviFirElencoFIRBlocchi';
import { allegatiForm, allegatiGriglia, tagAllegati } from './templates/allegati';
import { cambioPasswordForm } from './templates/cambioPasswordProfilo';
import { configurazioneDatabaseAziendale } from './templates/configurazioneDatabaseAziendale';
import { consumoRegistriXml } from './templates/consumoRegistriXml';
import { creaRegistroRentri } from './templates/creaRegistroRentri';
import { crmAgentiForm, crmAgentiGrid } from './templates/crm-agenti';
import { crmBancheForm, crmBancheGrid } from './templates/crm-banche';
import { crmProcedureForm, crmProcedureGrid, crmProcedureModificaPrezzi } from './templates/crm-procedure';
import { crmTipoProcedureForm, crmTipoProcedureGrid } from './templates/crm-tipo-procedure';
import { crmAggiornamentiFiltri, crmAggiornamentiGrid } from './templates/crmAggiornamenti';
import { CrmContattiForm, CrmContattiGrid, crmContattiSedeForm, crmContattiSedeGrid, CrmContattoExtra, crmContattoInformazioniGenerali, crmElencoRecapitiContattoForm, crmElencoRecapitiContattoGrid, crmExportMailForm, crmInviaContrattoForm, crmStampaContrattoForm } from './templates/crmContatti';
import { crmDiarioAttivitaContatto, crmDiarioAttivitaGrid } from './templates/crmDarioAttività';
import { diarioAttivitaDashBoardGrid } from './templates/crmDashboard';
import { elencoAttivitaForm, elencoAttivitaGrid } from './templates/crmElencoAttività';
import { crmEmailInviateGrid } from './templates/crmEmailInviate';
import { crmFilesForm, crmFilesGrid, crmFilesGridEmail } from './templates/crmFiles';
import { CrmProcedureDetail, CrmProcedureDetailForm, CrmProcedureMasterDetail, CrmProcedureMasterDetailForm } from './templates/crmProcedureDetail';
import { crmSendMessageEditForm, CrmSendMessaggeForm, crmSendMessaggeGrid } from './templates/crmSendMessagge';
import { esportazioneRentriRegistriGrid, rentriRegistriElaboratigrid, StampaRegistriCSGrid } from './templates/stampaRegistriCS';
import { CrmStatisticheProcedure } from './templates/crmStatisticheProcedure';
import { crmComuniForm, crmComuniGrid, crmTagContattoCommercialiGrid, crmTagContattoEconomiciGrid, crmTagContattoStatisticheGrid, crmTagsForm, crmTagsGrid, crmTagTipoContattoGrid } from './templates/crmTagContatto';
import { DettagliGiacenzeIniziali } from './templates/dettagliGiacenzeIniziali';
import { emissioneFormulariFiltri } from './templates/emissioneFormulariFiltri';
import { formSalvataggioModello } from './templates/formSalvataggioModello';
import { campoButton, campoCodiceDesc, campoDynamic, campoLista, campoListaM, campoSemplice, generaConfigurazione, generaGruppo } from './templates/generaForms';
import { gestioneUtenti } from './templates/gestioneUtenti';
import { GiacenzeIniziali, GiacenzeInizialiGrid, GiacenzeRifiuti, GiacenzeRifiutiFiltro, ListaMovimentiGiacenza } from './templates/giacenzeIniziali';
import { giacenzeMovimentoPanel } from './templates/giacenzeMovimentoPanel';
import { graficiGiacenze } from './templates/graficiGiacenze';
import { SettingGrid } from './templates/gridSettings/gridSettings';
import { attivaLicenza } from './templates/licenze';
import { listaCer } from './templates/listaCer';
import { lotto } from './templates/lotto';
import { RintraccMiscelazione } from './templates/miscelazione-rintracciabilita';
import { modelliStampa } from './templates/modelliStampa';
import { modificaAnteprimaPDF } from './templates/modificaAnteprimaPDF';
import { movimentiRifiutoFiltri, movimentiRifiutoFiltri2 } from './templates/movimentiRifiutoFiltri';
import { profiloForm } from './templates/profiloForm';
import { SchedaRifiutoLavorazione, SchedaRifiutoMiscelazione, SchedaRifiutoN } from './templates/schedarifiuti';
import { soggettiFiltri } from './templates/soggettiFiltri';
import { movimentiRifiutoProtocollati, movimentiRifiutoRegistri, stampaRegistriFiltri } from './templates/stampaRegistriFiltri';
import { stampaRegistriMovimenti } from './templates/stampaRegistriMovimenti';
import { caricoGiacenzeDetail, StatisticaRifiuti, StatisticaRifiutiDett } from './templates/statisticarifiuti';
import {
   addElencoDestinatari,
   addElencoProduttori,
   addElencoTrasportatori,
   movimentiRifiutiPerStatistica,
   movimentiRifiutiPerStatisticaMensile,
   statisticheRifiuti,
} from './templates/statisticheRifiuti';
import { strutturaExcel, strutturaExcelGriglia } from './templates/strutturaExcel';
import { testoAdr } from './templates/testoAdr';
import { unitaLocaliFiltri } from './templates/unitaLocaliFiltri';
import { crmEstrattoConto } from './templates/crmEstrattoConto';
import { rettifica } from './templates/rettifica_variazione';
import { crmCensimento } from './templates/crmCensimento';
import { SelezioneNsAzienda } from './templates/filtriFormulari';

export interface ISearchExpr {
   /** Campo necessario per controllare se serve inserito elemento padre ed effettuare alert */
   fatherDataField?: string;

   /** Nome Campo Array contenente oggetti */
   expand?: string;
   /** Nome Gruppo nel caso ci sia anche l'expand */
   headerField?: string;
   /** Variabile identificativa (es. id) */
   valueExpr?: string;
   /** Campi che devono essere utilizzati per la ricerca combinata */
   dataFields?: string[];

   related?: string[];
   /** Se expand è valorizzata filtra per gli oggetti annidati seconod le proprie necessità */
   optionalFilters?: {
      [key: string]: any;
   };
}
export interface GroupValidator {
   sourceDataField: string,
   targetDataField: string,
   operator: '=' | '!=' | '<' | '>' | '<=' | '>=',
   message: string,
   keyError: string //chiave dell'errore custom
}

export interface SearchOptions {
   api?: string;
   suffixOdata?: string; // puo essere $filter o $expand a seconda dell'opzioni odata, Se lascito vuoto o non utilizzato sarà sempre $filter=,
   service?: string;
   dataFieldToSearch: AnaColumn[] | any[]; //array di dati nei quali effetuare la ricerca oltre che a rappresentare a video il risultato della ricerca.
   dataFielToDisplay: any; //array di dati da utilizzare nell'oggetto selezionato che verranno rappresentare a video nel campo.
   dataFielValueExpr?: string;
   related?: any[]; // campi realzionati se diversi da quelli gia definiti dell'items
   queryString?: string; // queri string da aggiungere.
}

export class Validation {
   type: 'max' | 'min' | 'required' | 'minLength' | 'maxLength' | 'pattern' | 'range' | 'stringLength' | 'compare' | 'email'; //probabilmente da range in poi non servono ad un cazzo ma lasciamoli perchè sono stati usati da altre parti
   message: string;
   value?: number | string | RegExp


   max?: string | number;
   min?: string | number;
   pattern?: string;
   callBack?: any;
   rule?: any;
   comparisonType?: any;
   comparisonTarget?: any;
   reevaluate?: boolean;
}

export class costantValue {
   key: string;
   value: any;
}
export interface customTooltip { // Tooltip devextreme https://js.devexpress.com/Angular/Documentation/21_1/ApiReference/UI_Components/dxTooltip/
   height?: number | string;
   maxWidth?: number | string;
   content: string;
   typeContent: 'inputValue' | 'dynamicContent' | 'content' | 'listaContent';
   dynamicContent?: string;
   startVisible?: boolean;
   showEvent?: {
      name: string;
      delay: number;
   };
   hideEvent?: {
      name: string;
      delay: number;
   };
   animation?: { // Animazione di devextreme https://js.devexpress.com/Angular/Documentation/21_1/ApiReference/Common/Object_Structures/animationConfig/
      hide: {
         type: 'fade' | 'slide' | 'pop' | 'css',
         from: number | string | { [key: string]: any },
         to: number | string | { [key: string]: any },
         duration?: number,
         delay?: number,
      };
      show: {
         type: 'fade' | 'slide' | 'pop' | 'css',
         from: number | string | { [key: string]: any },
         to: number | string | { [key: string]: any },
         duration?: number,
         delay?: number,
      };
   };
   position?: {
      my: 'bottom' | 'center' | 'left' | 'left bottom' | 'left top' | 'right' | 'right bottom' | 'right top' | 'top';
      at: 'bottom' | 'center' | 'left' | 'left bottom' | 'left top' | 'right' | 'right bottom' | 'right top' | 'top';
      offset?: string;
   }
}
export class dynamicGrid {
   dynamic?: {
      costantValue?: costantValue[];
      dataSource: any;
      service?: string;
      valueExpr: string;
      displayExpr: any;
      componentType?: string;
      queryString?: string;
      filterStatic?: string; //Vedi FormTemplate MovimentiRifiuti
      related?: any[];
      settingGrid?: {
         campoTabRif?: string;
         masterKey?: any;
         keyUnique?: any;
         selectionMode?: string;
         remoteOperations?: boolean;
         hoverStateEnabled?: boolean;
         sortingMode?: string;
         rowAlternationEnabled?: boolean;
         repaintChangesOnly?: boolean;
         searchAndSelect?: boolean;
         searchAndSelectDataSource?: string;
         allowUpdating?: boolean;
         allowDeleting?: boolean;
         allowAdding?: boolean;
         width?: number;
         height?: number;
         mode?: string;
         showColBlank?: boolean;
         desButtonAdd?: string;
         outputData?: boolean;
         dataInput?: any;
         showFilterSearch?: boolean;
         rowDragging?: {
            allowReordering?: boolean;
            showDragIcons?: boolean;
         };
         colonne?: {
            dataField: string;
            type?: string;
            width?: number;
            dataType: string;
            caption?: string;
            colWidth?: string;
            colVisible?: boolean;
            hideOnEdit?: boolean;
            disableOnUpdate?: boolean;
            groupIndex?: number;
            showEditorAlways?: boolean;
            falseText?: string;
            trueText?: string;
            defaultValue?: any;
            class?: string;
            allowEditing?: boolean;
            lista?: any;
         }[];
         enabledCustomButton?: boolean;
         toolbarButtons?: ButtonForm[];
      };
      settingList?: settingList;
      settingDetail?: any[];
   };
}

export class IconStateVisual {
   type: 'custom' | 'icon'
   iconTrue?: {
      iconClass: string,
      style?: string
   }
   iconFalse?: {
      iconClass: string,
      style?: string
   }
   customTrue?: {
      html: string,
      class?: string,
      style?: string
   }
   customFalse?: {
      html: string,
      class?: string,
      style?: string
   }
   trueValue: string | boolean | number
   falseValue: string | boolean | number
}

export class detailOptions {
   costantValue?: costantValue[];
   isRemote: boolean;
   service: string;
   api: string;
   isEditable: boolean;
   queryString: string;
   colonne?: {
      dataField: string;
      dataType?: string;
      caption: string;
      allowEditing?: boolean;
      colVisible?: boolean;
      colWidth: number | any;
   }[];
}

export class ButtonForm {
   /**Nome identificativo bottone*/
   name?: string;
   hint?: string;
   icon?: string;
   location?: string;
   text?: string;
   type?: string;
   stylingMode?: string;
   event?: string;
   outPutValue?: boolean;
   componentType?: string;
   componentOutPut?: string;
   related?: any[];
   disabled?: boolean;
   class?: string;
   accesskey?: string;
   visible?: boolean;
   mode?: any;
}
export class _dxoSummary {
   summaryType: string;
   showInGroupFooter: boolean;
   alignByColumn?: boolean;
   groupDataField?: string;
   valueFormat?: string; //="currency"
   displayFormat?: string; //="Totale: {0}"
   alignment?: string;
}
export class settingList {
   scrollingEnabled: boolean;
   selectionMode: string;
   showSelectionCheckBox: boolean;
   showScrollbar: string;
   keyExpr: string;
   width?: number;
   height?: number;
   disabled?: boolean;
   showDropDownButton?: boolean;
   remoteOperations?: boolean;
}
export class settingDetail {
   chiave: any;
   titolo: string;
   api: string;
   service?: string;
   remote: boolean;
   filter?: string;
   queryString?: any;
   filterStatic?: any;
   subDetail?: settingDetail[];
   elimina?: boolean;
   aggiungi?: boolean;
   modifica?: boolean;
   width?: number;
   colonne?: {
      dataField: string;
      dataType?: string;
      caption?: string;
      visible?: boolean;
      hideOnEdit?: boolean;
      disableOnUpdate?: boolean;
      allowEditing?: boolean;
      showEditorAlways?: boolean;
      groupIndex?: any;
      lista?: {
         dataSource: any;
         valueExpr: string;
         displayExpr: any;
         caption?: string;
         static?: boolean;
         filterStatic?: string; //Filtro statico ODATA
         queryString?: string;
         related?: any[];
         cascading?: any[];
         showDropDownButton?: boolean;
         showClearButton?: boolean;
         placeholder?: string;
         items?: any;
      };
   }[];
}
export class Widget {
   'cer': {};
}
export class AnaColumn {
   configuration?: {
      //inserisci i dati passati in input al componente 
      [key: string]: any,
      //altri dati 
      popUpPosition?: 'top' | 'center' | 'bottom';
   };
   form?: {};
   itemType?: string;
   dataType?: string; //il tipo che deve essere stampato nella cella
   placeHolder?: string; //Quale dei campi presente di questo formTemplate devo usare per la getBy
   apiRelazionale?: string; //Come deve essere fatta la chiamata
   displayRelazionale?: string[]; //Elementi da far vedere nella cella della colonna nuova
   caption?: string;
   captionClass?: string;
   colCount?: any;
   colSpan?: any;
   class?: string;
   titolo?: string;
   groupDataField?: string; //In caso di deve raggruppare i campi per il submit
   disabled?: boolean;
   visible?: boolean;
   componentType?: string; //Nome componente, grid  o list per nicaForm altrimenti il Nome del componente (NO DX) da aprire
   groupWidth?: number; // larghezza del gruppo in px
   colGroup?: number; // larghezza del gruppo in flexBaic da 1 = 10% a 10 = 100%
   groupValidation?: GroupValidator[];//validare più campi di una form confrontandoli fra loro
   data?: {
      nCol?: any;
      nonEditabile?: boolean //serve a non editabile il campo 
      colClass?: string;
      odataType?: string; // integer, select, string,boolean
      odataFilter?: string; //
      clone?: string; // nome della field da clonare
      //"!", "=", "<>", ">", ">=", "<", "<=", "startswith", "endswith", "contains", "notcontains".
      staticDataField?: string; // pezzotto per i campi dynamic selec in quanto cambia la datafield
      placeHolder?: string; //Quale dei campi presente di questo formTemplate devo usare per la getBy
      patterns?: string;
      isMultiple?: boolean;
      acceptOnlyCharacters?: any;
      sortOrder?: string;
      customFileName?: string
      allowFiltering?: boolean;
      tipoTotale?: string; // Tipo Totale count,min,sum,max,avg se esiste
      dxoSummary?: _dxoSummary;
      showInSummary?: boolean; //mostra il riepilogo in fondo alla lista no nicaAnagrafica
      name?: string;
      src?: string;
      orderGriglia?: number;
      visibleIndex?: number;
      prog?: number;
      hideInput?: boolean;
      showClearButton?: boolean;
      hidingPriority?: number; //usate in combo con columnHidingEnabled nella dataGrid, per dare priorità ad ogni singolo campo se non inserito ragiona di default, numero incrementale
      hideClock?: boolean;
      autoClear?: boolean; // Usato in campoIcon
      helpText?: string;
      class?: string;
      colAlignment?: string;
      editorClass?: string;
      type: string;
      attr?: string;
      colSpan?: any;
      colCount?: string;
      trueText?: string; //In griglia
      falseText?: string; //In griglia
      showEditorAlways?: boolean;
      allowEditing?: boolean;
      disableOnUpdate?: boolean;
      hideOnEdit?: boolean;
      readonly?: boolean;
      dataField?: string;
      dragEnabled?: boolean;
      dropEnabled?: boolean;
      dataType?: string;
      width?: any;
      height?: any;
      caption?: string;
      tipoSelect?: string;
      required?: boolean;
      mask?: string;
      fileAccepted?: string[];
      labelPosition?: string;
      labelAlignment?: string;
      labelColon?: boolean;
      labelVisible?: boolean;
      labelWidth?: number;
      maxLength?: any;
      max?: number;
      min?: number;
      maxSize?: number;
      minLength?: string;
      disabled?: boolean;
      editorType?: string;
      mode?: string;
      colVisible?: boolean;
      showInColumnChooser?: boolean;
      showDropDownButton?: boolean;
      allowHiding?: boolean;
      allowFixing?: boolean;
      allowSorting?: boolean;
      colWidth?: string | number;
      columnMinWidth?: string | number;
      colCaption?: string;
      button?: ButtonForm;
      buttonArray?: ButtonForm[];
      buttongrid?: ButtonForm;
      buttongroup?: ButtonForm[];
      verticalAlignment?: string;
      horizontalAlignment?: string;
      validation?: Validation[];
      format?: string;
      costantValue?: costantValue[]; // viene usato per impostare colonne in nuovo record
      defaultValue?: any; // valore di default per newrow
      iconButton?: boolean;
      isCostantValue?: boolean; //identifica in NICA ANAGRAFICA COMPONENT se il valore è costante da inviare sempre nell chiamate post e put
      cellTemplate?: boolean; //Per gestire nella griglia la funzione cellTemplate
      groupIndex?: number;
      visible?: boolean;
      uppercase?: boolean; //permette di scrivere il campo sempre in maiuscolo
      minDate?: any;
      dateSerializationFormat?: "yyyy-MM-dd" | "yyyy-MM-ddTHH:mm:ss" | "yyyy-MM-ddTHH:mm:ssZ" | "yyyy-MM-ddTHH:mm:ssx" | "yyyy-MM-ddTHH:mm:ssxx" | "yyyy-MM-ddTHH:mm:ssxxx" | "yyyy" | "MM" | "dd"
      calendarOptions?: {
         activeStateEnabled?: boolean;
         disabled?: boolean;
         disabledDates?: Function | Array<Date>;
         elementAttr?: any;
         firstDayOfWeek?: number | string;
         focusStateEnabled?: boolean;
         height?: number | Function | string;
         hint?: string;
         hoverStateEnabled?: boolean;
         max?: Date | number | string;
         maxZoomLevel?: string;
         min?: Date | number | string;
         minZoomLevel?: string;
         name?: string;
         readOnly?: boolean;
         value?: Date | number | string;
         visible?: boolean;
         width?: number | Function | string;
         zoomLevel?: string;
      }
      dxdropdownbox?: {
         showClearButton?: boolean;
         dataSource: any;
         valueExpr: string;
         displayExpr: string;
         caption?: string;
         filter?: string;
         queryString?: string;
         colonne?: {
            dataField: string;
            dataType: string;
            caption?: string;
            visible?: boolean;
            hideOnEdit?: boolean;
            disableOnUpdate?: boolean;
            //--------------
         }[];
      };
      switchBox?: {
         trueValue: any
         falseValue: any
         defaultValue: any
         switchedOnText?: string
         switchedOffText?: string
         classe?: string
         readOnly?: boolean
         width?: number
         height?: number
         hint?: string
         hoverStateEnabled?: boolean
      };
      lookup?: {
         instanceGrid?: any;
         wingap?: boolean;
         titolo?: string;
         dataSource: any;
         valueExpr: string;
         displayExpr: string;
         caption?: string;
         filter?: string;
         queryString?: string;
         checkVersion?: boolean;
         related?: any[];
         allowAdding?: boolean;
         allowUpdating?: boolean;
         allowDeleting?: boolean;
         showClearButton?: boolean;
         mode?: string; //row=edit in line o popup
         static?: boolean;
         widthOnOpened?: any;
         colonne?: {
            dataField: string;
            dataType?: string;
            caption?: string;
            visible?: boolean;
            hideOnEdit?: boolean;
            disableOnUpdate?: boolean;
            groupIndex?: any;
            colWidth?: any;
            lookup?: {
               prog?: any;
               filter?: string;
               id?: any;
               wingap?: boolean;
               dataSource: any;
               valueExpr: string;
               displayExpr: string;
            };
         }[];
         campiVista?: any[];
         settingList?: settingList;
      };
      iconStateVisual?: IconStateVisual
      lista?: {
         selectFirstElement?: boolean;
         dataSource: any;
         wingap?: boolean,
         defaultOptionTxt?: string,
         valueExpr: string;
         displayExpr: any;
         listadisplayExpr?: string;
         caption?: string;
         static?: boolean;
         Async?: boolean;
         filter?: string;
         filterStatic?: string; //Filtro statico ODATA
         filterPath?: string; //solo per la form nella request è l'id di riferimento https://api.it/dataSource/id
         queryString?: string;
         template?: string;
         settingList?: settingList;
         related?: any[];
         cascading?: any[];
         showDropDownButton?: boolean;
         colonne?: Column[];
         showClearButton?: boolean;
         placeholder?: string;
         items?: any;
         isMultiple?: boolean;
         searchEnable?: boolean;
         tipoSelect?: any;
         showSelectionControls?: boolean;
         labelSelect?: any;
         staticOptions?: any;
         isDefaultOption?: boolean;
         dropEnabled?: any;
         dragEnabled?: any;
         width?: string;
         widthOnOpened?: any;
         costantValues?: costantValue[]//serve bper rimuovere i costant value da nica anagrafica al momento
         keyExpr?: string //serve per dare a devextreme un id di riconoscimento diverso per la selezione del record che sia diverso dalla key 'id'
         isUnselected?: boolean
      };
      radioGroup?: {
         dataSource?: any;
         valueExpr?: string;
         displayExpr?: any;
         layout?: string;
         static?: boolean;
         filter?: string;
         /** Valore di Default */
         defaultValue?: any;
         filterStatic?: string; //Filtro statico ODATA
         filterPath?: string; //solo per la form nella request è l'id di riferimento https://api.it/dataSource/id
         queryString?: string;
         template?: string;
         related?: any[];
         cascading?: any[];
         items?: any[];
      };
      tagBoxList?: {
         dataSource: any;
         valueExpr: string;
         displayExpr: any;
         itemTemplate?: string;
         maxDisplayedTags?: number;
         multiline?: boolean;
         opened?: boolean;
         showSelectionControls?: boolean;
         typeSendData?: string;
         queryString?: string;
         showClearButton?: boolean;

         related?: any[];
      };
      autocomplete?: {
         dataSource: any;
         valueExpr: string;
         displayExpr: string;
         minSearchLength?: number;
         filter?: string;
         queryString?: string;
         static?: boolean;
         related?: any[];
         cascading?: any[];
      };
      // modifica adele :
      staticCheckboxes?: {
         type: any;
         caption: string;
         options: any;
      };
      customTooltip?: customTooltip;
      checkBox?: {
         event?: {
            type?: string;
            key?: string;
            value?: any[];
         };
      };

      dynamic?: {
         costantValue?: costantValue[];
         dataSource: any;
         service?: string;
         tipoSelect?: string;
         api_rest?: boolean;
         /**Dati da passare al popup */
         popupWidth?: any;
         popupHeight?: any;
         positionPopUp?: any;
         /**Fine dati da passare al popup */
         autocomplete?: boolean;
         checkValue?: {
            checkValueMessage?: string;
            forceInsert: boolean;
         };

         valueExpr: any;
         displayExpr: any;
         searchExpr?: ISearchExpr | string;
         searchOptions?: SearchOptions;
         caption?: string;
         static?: boolean;
         enableEditor?: {
            add?: boolean;
            remove?: boolean;
            update?: boolean;
         };
         componentType?: string;
         keyUnique?: string;
         filter?: string;
         bodyFilter?: any;
         filterStatic?: string; //Vedi FormTemplate MovimentiRifiuti
         campoTabRif?: string;
         queryString?: string;
         related?: any[];
         correlateDataField?: string;
         campiVista?: any[];
         dataFormFilter?: any; //filtra il data source dai dati ricevuti dalla form, è sempre un array
         buttonOption?: ButtonForm;
         buttons?: ButtonForm[];

         settingGrid?: SettingGrid;

         settingList?: settingList;
         settingDetail?: dynamicGrid;
         detailOption?: detailOptions;
      };

      buttons?: {
         text?: string;
         value?: string;
         name?: string;
         icon?: string;
         badge?: string;
         event?: string;
         hint?: string;
         outPutValue?: boolean;
         related?: any[];
         location?: string;
         wPopUp?: string;
         hPopUp?: string;
         costantValue?: any;
         displayMode?: string;
         dataSource?: string;
         visible?: boolean;
         items?: {
            value?: string;
            name?: string;
            icon?: string;
            badge?: string;
            event?: string;
            hint?: string;
            location?: string;
            displayMode?: string;
            visible?: boolean;
         }[];
      }[];
      component?: {
         name?: string;
         nameComponent: string;
         configuration?: { static: boolean, [key: string]: any }
      };
      dateTime?: {
         related?: any[];
      };
      items?: any[];
      formGrid?: {
         service: string; //service di riferimento
         api: string; //api di swager
         colonne?: any[]; // colonne a mano se non si vuole passare dal service
         remoteOperation?: boolean; // è una griglia statica? No allora sara true
         rowAlternate?: boolean; // Ancora da gestire nell'html
         dataJson?: any; //Mandiamogli dei dati come filtri o tutta la form a questa griglia possono sempre servire
         queryString?: string; //la query string che può servire nelle api es ?idOggetto=1
         isEditable?: boolean; // saà una griglia modificabile
         isEditableNewRow?: boolean; // puoi inserire una nuova riga?
         isEditableEditRow?: boolean; // puoi modificare le righe?
         isEditableDeleteRow?: boolean; // puoi eliminare le righe?
         tableHeight?: number; //Che altezza gli dai?
         tableWidth?: number; // che larghezza avrà?
         showFilter?: boolean; //Vuoi mostrare i filtri sotto la testata della griglia? bhe fai attenzione va sviluppata ancora sta funzione
         showToolbarBottom?: boolean; // devi far apparire dei bottoni sotto la griglia?
         toolbarButtonsBottomRight?: any[]; // Quali bottoni prevedi di fare vedere sotto ala griglia spostati a destra? vedi leggenda nel componente caption
         toolbarButtonsTopRight?: any[]; // Quali bottoni prevedi di fare vedere sotto ala griglia spostati a sinistra? vedi leggenda nel componente caption
         selectionRowMode?: string; // 'single' | 'detail' | 'multiple';
         selectedData?: []; //è una array sono le righe che appaiono già selezionate
         showCaptionFooter?: boolean;
         showCaptionHeader?: boolean;
         idTable?: any;
         showToolbarTop?: boolean;
         toolbarCustomButtons?: any[];
         isSearchable?: boolean;
         detailOptions?: detailOptions;
         isOdata?: boolean;
         queryStringInEditor?: string; //Una querysting se ne hai bisogno solo per la modifica,l'inserimento e l'eliminazione
         isKeyID?: boolean; //se false la put sarà senza /id
         notTestQuery?: boolean;
      };
   }[];
}
const generic = tipo;
let tipopin = [
   { id: 0, descrizione: 'SMS' },
   { id: 1, descrizione: 'E-MAIL' },
];

//
let prodottoDaGestione = [
   { id: 'S', descrizione: 'Si' },
   { id: 'N', descrizione: 'No' },
];

let PeriodicitaCaratterizzazione = [
   { id: 'A', descrizione: 'Regolare, senza modifica ProcessoProduttivo' },
   { id: 'B', descrizione: 'Regolare con modifica pp' },
   { id: 'C', descrizione: 'Non Regolare' },
];

let AvvenutoSmaltimento = [
   { id: 0, descrizione: 'Solo Si' },
   { id: 1, descrizione: 'Solo No' },
   { id: 2, descrizione: 'Si e No' },
];
let tipoAnalisiList = [
   {
      id: 'A', descrizione: 'Analisi'
   },
   {
      id: 'C', descrizione: 'Classificazione'
   },

];

let tipoVettore = [
   { id: 1, descrizione: 'Terrestre' },
   { id: 2, descrizione: 'Ferroviario' },
   { id: 3, descrizione: 'Marittimo' },
];

let TendenzaPercolato = [
   { id: 'N', descrizione: 'Nulla' },
   { id: 'A', descrizione: 'Alta' },
   { id: 'M', descrizione: 'Media' },
   { id: 'B', descrizione: 'Bassa' },
];
let TipoCalcolo = [
   { id: 'P', descrizione: 'Dato il peso calcola il volume' },
   { id: 'V', descrizione: 'Dato il volume calcola il peso' },
];
let TipoRaee = [
   { id: 'D', descrizione: 'RAEE Domestici' },
   { id: 'P', descrizione: 'RAEE Professionali' },
];

let visibilita = [
   { id: 1, descrizione: 'Privato' },
   { id: 2, descrizione: 'Pubblico' },
   { id: 3, descrizione: 'Modificabile' },
];

let TipoTrasporto = [
   { id: 'N', descrizione: 'Nessun Trasporto' },
   { id: 'P', descrizione: 'Proprio' },
   { id: 'T', descrizione: 'Terzi' },
   { id: 'X', descrizione: 'Misto' },
   /* { id: 'X', descrizione: "Ns Azienda / Terzi" }, */
];
let tipoTags = [
   { id: 1, descrizione: 'Statistiche' },
   { id: 2, descrizione: 'Rapporti Commerciali' },
   { id: 3, descrizione: 'Rapporti Economici' },
   { id: 4, descrizione: 'Disattivazione' },
   { id: 5, descrizione: 'Stat. Agenti' },
   { id: 6, descrizione: 'boh3' },
   { id: 7, descrizione: 'boh4' },
];

let tipoAutomezzi = [
   { id: 'M', descrizione: 'Motrice' },
   { id: 'R', descrizione: 'Rimorchio' },
   { id: 'T', descrizione: 'Trattore' },
   { id: 'S', descrizione: 'Scarrabile' },
];
let tipoAttivita = [
   { id: 'P', descrizione: 'Produzione' },
   { id: 'T', descrizione: 'Trasporto' },
   { id: 'S', descrizione: 'Impianto' },
   { id: 'I', descrizione: 'Intermediazione' },
];
let tipoAttivitaAutorizzazione = [
   { id: 'P', descrizione: 'Produzione rifiuti' },
   { id: 'S', descrizione: 'Destinatario/Smaltimento' },
];
const stati = [
   { id: 1, name: 'Chiuso' },
   { id: 0, name: 'Aperto' }
]
let statistica = [
   //{id: 1, descrizione: 'Distinta Rif. C.E.R.'},
   //{id:2,descrizione:'Distinta Rif. C.E.R. + Tipol. + St.Fisico'},
   { id: 3, descrizione: 'Distinta Rif. C.E.R. + Riferimento + St.Fisico' },
   { id: 4, descrizione: 'Riepilogo Giornaliero/Mensile' },
   { id: 5, descrizione: 'Elenco Movimenti' },
   { id: 6, descrizione: 'Produttori non Movimentati' },

   //{id:7,descrizione:'Tabelle a più livelli'},
   //{id:9,descrizione:'Distinta Addebiti Var e rif.'},
   //{id:10,descrizione:'Dettagli Addebiti Var e rif.'},
   //{id:11,descrizione:'Totale Addebiti Variabili'},
   //{id:12,descrizione:'Riepilogo importi conferime.Produzione Rifiuti'},
];
/*
isIntermediario:true
isProduttore:true
isSmaltitore:true
isTrasportatore:true
*/
const statisticaPerGrafici = [
   { id: 1, descrizione: 'Distinta Rif. E.E.R.' },
   { id: 2, descrizione: 'Distinta Rif. E.E.R. + Tipol. + St.Fisico' },
   { id: 3, descrizione: 'Distinta Rif. E.E.R. + Riferimento' },
   { id: 4, descrizione: 'Riepilogo Giornaliero/Mensile' },
   { id: 5, descrizione: 'Totale Raggruppamento per Cliente' },
   { id: 6, descrizione: 'Totale Raggruppamento per Produttore' },
   { id: 7, descrizione: 'Totale Raggruppamento per Trasportatore' },
   { id: 8, descrizione: 'Totale Raggruppamento per Smaltitore' },
];
const tipoAttivitaBoolean = [
   { id: 'P', descrizione: 'Produzione' },
   { id: 'T', descrizione: 'Trasporto' },
   { id: 'S', descrizione: 'Impianto' },
   { id: 'I', descrizione: 'Intermediazione' },
];
const accettaModuli = [
   { id: null, value: 'No' },
   { id: 0, value: 'No' },
   { id: 1, value: 'Si' },
]
const tipoutente = [
   { id: 1, descrizione: 'OWNER' },
   { id: 2, descrizione: 'SUPER ADMINISTRATOR' },
   { id: 3, descrizione: 'ADMINISTRATOR' },
   { id: 4, descrizione: 'ADVANCED USER' },
   { id: 5, descrizione: 'STANDARD USER' },
   { id: 6, descrizione: 'UTENTE RENTRI' },
   { id: 7, descrizione: 'API USER' },
   { id: 8, descrizione: 'APP USER' },
   { id: 9, descrizione: 'API USER ESTERNO' },
   { id: 10, descrizione: 'AGENTE' },
   { id: 11, descrizione: 'UTENZA SEGRETERIA' },
];



let modalitaUtenteApp = [
   { id: 1, descrizione: 'AUTISTA' },
   { id: 2, descrizione: 'PRODUTTORE' },
   { id: 3, descrizione: 'INTERMEDIARIO' },
   { id: 4, descrizione: 'CONSULENTE' },
   { id: 5, descrizione: 'ASSOCIAZIONE' },
];

let provinciePP: any = [];
let RadioSiNo = [
   { id: true, text: 'Si' },
   { id: false, text: 'No' },
];

let RadioAssegnaProtocolli = [
   { id: 'S', text: 'In Stampa' },
   { id: 'R', text: 'In Registrazione' },
];

let RadioSiNoString = [
   { id: 'S', text: 'Si' },
   { id: 'N', text: 'No' },
];

let modSmaltimento = [
   { id: 1, codice: 'R1' },
   { id: 2, codice: 'R2' },
   { id: 3, codice: 'R3' },
   { id: 4, codice: 'R4' },
   { id: 5, codice: 'R5' },
   { id: 6, codice: 'R6' },
   { id: 7, codice: 'R7' },
   { id: 8, codice: 'D1' },
];

let um = [
   { id: 'Kg', descrizione: 'Kg' },
   { id: 'litri', descrizione: 'L' },
];
let accettazioneTipo = [
   { id: 'A', descrizione: 'Accettato per intero' },
   { id: 'P', descrizione: 'Accettato parzialmente' },
   { id: 'R', descrizione: 'Respinto' },
];

const Disabilitato = [
   { id: 1, descrizione: '🔴', value: '' },
   { id: 0, descrizione: '🟢', value: '' },
   { id: 2, descrizione: '🔵', value: '' },
   { id: 3, descrizione: '🟣', value: '' },
   { id: 4, descrizione: '🟡', value: '' },
]
const stCliente = [
   { key: 0, value: 'Sospeso' },
   { key: 1, value: 'Attivo' },
   { key: 2, value: 'Ex Cliente' },
   { key: 4, value: 'Ex Cliente con Agente' },
   { key: 3, value: 'Altro' },
]
const Stato = [
   { id: 0, descrizione: '🔴' },
   { id: 1, descrizione: '🟢' },
]
const modelloStampaRegistroRifiuti = [
   { id: '0', descrizione: '    ' },
   { id: '1', descrizione: 'A4' },
   { id: '2', descrizione: 'Registro A2 laser (Biano e nero)' },
   { id: '2', descrizione: 'Registro A2 laser (Vert. Grafico)' },
   { id: '4', descrizione: 'Registro C/S Modello A2' },
];
const assegnazioneProcolloMovimentiRifiuti = [
   { id: '1', descrizione: 'Assegna protocolli in fase di stampa definitiva' },
   { id: '2', descrizione: 'Assegna protocolli in fase di registrazione documento' },
];

const vociObbligatorie = [
   { id: 'A', descrizione: 'Avvisare' },
   { id: 'B', descrizione: 'Bloccare' },
];

const attivitaFuoriUl = [
   { id: 'S', descrizione: 'Assistenza sanitaria' },
   { id: 'B', descrizione: 'Bonifica Amianto' },
   { id: 'C', descrizione: 'Cantieri esterni o temporanei' },
   { id: 'M', descrizione: 'Manutenzioni' },
   { id: 'X', descrizione: 'Altro (no RE in mud)' },
];

let moduli = [
   { id: 'rentri', descrizione: 'RENTRI' },
   { id: 'vivifir', descrizione: 'VIVIFIR' },
];

let tipoPCE = [
   {
      id: 'P',
      descrizione: 'Privato',
   },
   {
      id: 'C',
      descrizione: 'Comune',
   },
   {
      id: 'E',
      descrizione: 'Distributore RAEE',
   },
];
let elaboraMUD = [
   {
      id: 'S',
      descrizione: 'SI',
   },
   {
      id: 'N',
      descrizione: 'NO',
   },
];

let formatiFoglio = [
   {
      id: 'A1',
      descrizione: 'A1',
   },
   {
      id: 'A2',
      descrizione: 'A2',
   },
   {
      id: 'A3',
      descrizione: 'A3',
   },
   {
      id: 'A4',
      descrizione: 'A4',
   },
   {
      id: 'A5',
      descrizione: 'A5',
   },
];

let tipoMUD = [
   {
      id: 'S',
      descrizione: 'CER pericolosi e non',
   },
   {
      id: 'N',
      descrizione: 'Solo CER pericolosi',
   },
   {
      id: 'C',
      descrizione: 'CER pericolosi e non ma con almeno uno pericoloso',
   },
];

let tipoRaee = [
   {
      id: 'D',
      descrizione: 'RAEE Domestici',
   },
   {
      id: 'P',
      descrizione: 'RAEE Professionali',
   },
];
let imballaggioRicevuto = [
   {
      id: 'N',
      descrizione: 'No',
   },
   {
      id: 'C',
      descrizione: 'Si,pubblico',
   },
   {
      id: 'E',
      descrizione: 'Si,non pubblico',
   },
];
let operazioneVeicoliFuoriUso = [
   {
      id: 'A',
      descrizione: 'Autodemolizione',
   },
   {
      id: 'R',
      descrizione: 'Rottamazione',
   },
   {
      id: 'F',
      descrizione: 'Frantumazione',
   },
   {
      id: 'N',
      descrizione: 'Non rientra in Veicoli Fuori Uso',
   },
];

let sottoGruppi = [
   {
      id: 0,
      descrizione: 'Colonne Presenti',
   },
]; //=getSottogruppi('Elenco Produttori',true);

const tipoFormulario = [
   { id: 'C', descrizione: 'Cartaceo' },
   //{ id: 'B', descrizione: 'Bolla' },
   //{ id: 'R', descrizione: 'Rentri' },
   { id: 'V', descrizione: 'ViviFir' },
   //{ id: 'S', descrizione: 'Servizi' },
];
const statisticaFiltroMovimenti = [
   { id: '1', descrizione: 'Escludi movimenti completamente scaricati' },
   { id: '2', descrizione: 'Solo movimenti con avviso Smaltimento confermato' },
   { id: '3', descrizione: 'Solo movimenti con avviso Smaltimento non confermato' },
   { id: '4', descrizione: 'Solo carichi già trattati' },
   { id: '5', descrizione: 'Seleziona manuale movimenti' },
];
const statisticaTipoRaggruppamento = [
   //{ id: '1', descrizione: 'Nessuno' },
   { id: '2', descrizione: 'Produttore' },
   { id: '3', descrizione: 'Trasportatore' },
   { id: '4', descrizione: 'Smaltitore' },
   { id: '5', descrizione: 'Intermediario' },
   { id: '6', descrizione: 'Causale' },
   { id: '7', descrizione: 'Posizione' },
   //{ id: '6', descrizione: 'CER' },
   //{ id: '7', descrizione: 'Produttore/CER' },
];

const statiDiario = [
   { key: 1, value: "Aperto" },
   { key: 0, value: "Presa in carico" },
   { key: 2, value: "Chiuso" },
]

const TipoCarico = [
   { id: '1', descrizione: 'Carico in deposito temporaneo' },
   { id: '2', descrizione: 'Carico da terzi in R' },
   { id: '3', descrizione: 'Carico da produzione in R' },
   { id: '4', descrizione: 'Carico da terzi in D' },
   { id: '5', descrizione: 'Carico da produzione in D' },
];
const StatisticheRifiuti = [
   { id: '1', descrizione: 'Carico in deposito temporaneo' },
   { id: '2', descrizione: 'Carico da terzi in R' },
   { id: '3', descrizione: 'Carico da produzione in R' },
   { id: '4', descrizione: 'Carico da terzi in D' },
   { id: '5', descrizione: 'Carico da produzione in D' },
];

const umVolume = [
   { id: 'M', descrizione: 'Metri Cubi' },
   { id: 'L', descrizione: 'Litri' },
];
const umMisuraMovimenti = [
   { id: 'K', descrizione: 'Kg' },
   { id: 'M', descrizione: 'Metri Cubi' },
   { id: 'L', descrizione: 'litri' },
];
const tipoAnalisi = [
   {
      id: 'A', descrizione: 'Analisi'
   },
   {
      id: 'C', descrizione: 'Classificazione'
   },
];

@Injectable({
   providedIn: 'root',
})
export class FormsTemplateService implements OnInit {
   aspect: any;
   constructor(private spinner: NgxSpinnerService, private appService: Apiservice, public utenteService: Utenteservice) {
      /*this.appService.GetProvincie()
      .then(response => {
        provinciePP = response;
        // console.log("BBBBBBBBBBBBB ",response);
      });*/
   }
   ngOnInit(): void {
      this.aspect = 7.7;
   }

   //Async

   async getDatiAsync(e: string, filter?: string) {
      if (e == 'CausaleRifiuti') {
         let ciccia = await this.appService.GetApi('CausaleRifiuti');
         return ciccia;
         await this.appService.GetApi('CausaleRifiuti').then((response: any[]) => {
            let ciccio = response;
            /*
        ciccio.forEach(element => {
          console.log(element)
          element['gruppo'] = element['id'].slice(0, 1);
        });*/
            console.log("rrrrrrrrrrrrr ", ciccio)
            return ciccio;
         });
      }

      if (e == 'idTipoOperazione') {
         await this.appService.GetApi('TipoOperazioneCausaleRifiuti').then((response) => {
            console.log('qqqqqqqqqqq ', response);
            return response;
         });
      }

      if (e == 'idOperazione') {
         this.appService.GetApi('OperazioneCausaleRIfiuti').then((response: any[]) => {
            let ciccio = response;
            ciccio.forEach((element) => {
               console.log(element);
               element['gruppo'] = element['id'].slice(0, 1);
            });
            console.log('rrrrrrrrrrrrr ', ciccio);
            return ciccio;
         });
      }

      if (e == 'RentriRegistroRifiuti') {
         this.spinner.show();
         let log = await this.appService.LoginRentriBySede(filter);
         //if(log==false) return ;
         let elenco = await this.appService.getRegistriElenco(filter);
         console.log('ecco elenco ', elenco);
         this.spinner.hide();
         return elenco;
      }
   }

   getDati(e: string, filter?: string) {
      if (e == 'CausaleRifiuti') {
         this.appService.GetApi('CausaleRifiuti').then((response: any[]) => {
            let ciccio = response;
            /*
        ciccio.forEach(element => {
          console.log(element)
          element['gruppo'] = element['id'].slice(0, 1);
        });*/
            console.log("rrrrrrrrrrrrr ", ciccio)
            return ciccio;
         });
      }

      if (e == 'idOperazione') {
         return this.appService.GetApi('OperazioneCausaleRIfiuti').then((response: any[]) => {
            let ciccio = response;
            ciccio.forEach((element) => {
               console.log(element);
               element['gruppo'] = element['id'].slice(0, 1);
            });
            console.log("rrrrrrrrrrrrr ", ciccio)
            return ciccio;
         });
      }

      if (e == 'idTipoOperazione') {
         this.appService.GetApi('TipoOperazioneCausaleRifiuti').then((response) => {
            console.log('qqqqqqqqqqq ', response);
            return response;
         });
      }
      if (e == 'RentriRegistroRifiuti') {
         this.appService.LoginRentriBySede(1).then((response) => {
            console.log('Ecco login 1 ', response);
            this.appService.getRegistriElenco(1).then((elenco) => {
               console.log('Ecco i registri ', elenco);
               return elenco;
            });
         });
         //LoginRentriBySede(sede)
      }

      //tipoAutomezzi
      /*
    const modelloStampaRegistroRifiuti
    const assegnazioneProcolloMovimentiRifiuti
    GetSediNsAziende
    */
      //PAPPA

      if (e == 'GetSediNsAziende') {
         //alert("wwwwwwwwwwwwwwwwwww");
         return this.appService.GetApi('soggetto?NostreAziende=S').then((response) => response['items']);
         //return modelloStampaRegistroRifiuti;
      }

      if (e == 'modelloStampaRegistroRifiuti') {
         return modelloStampaRegistroRifiuti;
      }
      if (e == 'Disabilitato') {
         return Disabilitato;
      }
      if (e == 'Stato') {
         return Stato;
      }
      if (e == 'assegnazioneProcolloMovimentiRifiuti') {
         return assegnazioneProcolloMovimentiRifiuti;
      }

      if (e == 'PeriodicitaCaratterizzazione') {
         return PeriodicitaCaratterizzazione;
      }
      if (e == 'AvvenutoSmaltimento') {
         return AvvenutoSmaltimento;
      }

      if (e == 'TendenzaPercolato') {
         return TendenzaPercolato;
      }
      if (e == 'tipoVettore') {
         return tipoVettore;
      }
      if (e == 'TipoCalcolo') {
         return TipoCalcolo;
      }
      if (e == 'TipoRaee') {
         return TipoRaee;
      }
      if (e == 'visibilita') {
         return visibilita;
      }
      if (e == 'stati') {
         return stati;
      }
      if (e == 'TipoTrasporto') {
         let returnData;
         switch (filter) {
            case 'D1':
               returnData = TipoTrasporto.filter((s) => s.id == 'P');
               break;
            case 'D2':
               returnData = TipoTrasporto.filter((s) => s.id == 'T');
               break;
            case 'E1':
               returnData = TipoTrasporto.filter((s) => s.id == 'T');
               break;
            case 'E2':
               returnData = TipoTrasporto.filter((s) => s.id == 'N');
               break;
            case 'E3':
               returnData = TipoTrasporto.filter((s) => s.id == 'N' || s.id == 'T');
               break;
            case 'E4':
               returnData = TipoTrasporto.filter((s) => s.id == 'N' || s.id == 'T');
               break;
            case 'E5':
               returnData = TipoTrasporto.filter((s) => s.id == 'N' || s.id == 'T');
               break;
            default:
               returnData = TipoTrasporto;
               break;
         }
         console.log(returnData)
         return returnData;
      }

      if (e == 'prodottoDaGestione') {
         return prodottoDaGestione;
      }

      if (e == 'tipoAutomezzi') {
         return tipoAutomezzi;
      }

      if (e == 'tipoAttivita') {
         return tipoAttivita;
      }
      if (e == 'tipoAttivitaAutorizzazione') {
         return tipoAttivitaAutorizzazione;
      }

      if (e == 'statistica') {
         return statistica;
      }

      // console.log("wwwwwwwwwwwwwwwwwwww ",e);
      if (e == 'cer') {
         return this.appService.GetApi('cer').then((response) => response['items']);
      }
      if (e == 'TipoOperazioneCausaleRifiuti') {
         return this.appService.GetApi('TipoOperazioneCausaleRifiuti').then((response) => response['items']);
      }

      if (e == 'OperazioneCausaleRIfiuti') {
         return this.appService.GetApi('OperazioneCausaleRIfiuti').then((response) => response['items']);
      }
      if (e == 'provincie') {
         console.log("vqqqqqqqqqqqqqqqqqqqqqq ", provinciePP);
         return this.appService.GetProvincie().then((response) => response);
      }
      if (e == 'tipopin') {
         return tipopin;
      }

      if (e == 'RadioAssegnaProtocolli') {
         return RadioAssegnaProtocolli;
      }
      if (e == 'RadioSiNoString') {
         return RadioSiNoString;
      }
      if (e == 'RadioSiNo') {
         return RadioSiNo;
      }

      if (e == 'vociObbligatorie') {
         return vociObbligatorie;
      }
      if (e === 'tipoTags') {
         return tipoTags
      }
      if (e == 'modSmaltimento') {
         return modSmaltimento;
      }
      if (e == 'tipoutente') {
         // elenco tipo utenti
         //return tipoutente;
         let risposta;
         let r = this.utenteService.DammiTipoUtente();
         if (r == 1) risposta = tipoutente.filter((s) => s.id == 2);
         else if (r == 2) risposta = tipoutente.filter((s) => s.id == 3);
         else if (r == 3) risposta = tipoutente.filter((s) => s.id > 3);
         risposta = tipoutente.filter((s) => s.id > r);
         return risposta;
      }
      if (e == 'um') {
         return um;
      }

      if (e == 'statistica') {
         return statistica;
      }
      if (e == 'tipoAnalisiList') {
         return tipoAnalisiList;
      }
      if (e == 'stCliente') {
         return stCliente;
      }

      if (e == 'sottoGruppi') {
         return sottoGruppi;
      }

      if (e == 'formatiFoglio') {
         return formatiFoglio;
      }

      if (e == 'accettazioneTipo') {
         return accettazioneTipo;
      }

      if (e == 'attivitaFuoriUl') {
         return attivitaFuoriUl;
      }

      if (e == 'moduli') {
         return moduli;
      }
      if (e == 'tipoPCE') {
         return tipoPCE;
      }
      if (e == 'elaboraMUD') {
         return elaboraMUD;
      }
      if (e == 'tipoMUD') {
         return tipoMUD;
      }

      if (e == 'tipoAttivitaBoolean') {
         return tipoAttivitaBoolean;
      }
      if (e == 'tipoFormulario') {
         return tipoFormulario;
      }
      if (e == 'umVolume') {
         return umVolume;
      }
      if (e == 'umMisuraMovimenti') {
         return umMisuraMovimenti;
      }
      //statisticaFiltroMovimenti
      if (e == 'statisticaFiltroMovimenti') {
         return statisticaFiltroMovimenti;
      }

      if (e == 'statisticaTipoRaggruppamento') {
         return statisticaTipoRaggruppamento;
      }
      if (e === 'statisticaPerGrafici') {
         return statisticaPerGrafici;
      }
      if (e == 'TipoCarico') {
         return TipoCarico;
      }
      if (e == 'statiDiario') {
         return statiDiario;
      }
      if (e == 'statiDiarioNoChiuso') {
         return statiDiario.filter((obj) => obj.value !== "Chiuso");
      }
      if (e == 'tipoAnalisi') {
         return tipoAnalisi;
      }
      if (e == 'tipoRaee') {
         return tipoRaee;
      }
      if (e == 'imballaggioRicevuto') {
         return imballaggioRicevuto;
      }
      if (e == 'operazioneVeicoliFuoriUso') {
         return operazioneVeicoliFuoriUso;
      }


   }

   getTemplateService(e: string, dataR?) {
      if (e == 'DammiInfoMovimento') {
         return {
            enabled: true, //Mettere a true per rimettere i dettagli come prima
            template: (td, data) => {
               let dataRow = data.data;
               let produttore = ' - ';

               let idMovimento = dataRow.id;
               let idTipoOperazione = dataRow.causale_Id_Operazione;
               let causale = dataRow.causale_Descrizione;
               let posizione = dataRow.posizioneRifiuto_Descrizione;
               let registroCarico = dataRow.registro_Descrizione_Carico ? dataRow.registro_Descrizione_Carico : ' ';
               let registroScarico = dataRow.registro_Descrizione_Scarico ? dataRow.registro_Descrizione_Scarico : ' ';
               let registroItermediazione = dataRow.registro_Descrizione_Intermediario ? dataRow.registro_Descrizione_Intermediario : ' ';
               let registroTrasporto = dataRow.registro_Descrizione_Trasporto ? dataRow.registro_Descrizione_Trasporto : ' ';
               let tipoOperazione = dataRow.idTipoCarico;

               switch (tipoOperazione) {
                  case 'DT':
                     tipoOperazione = 'Carico in deposito temporaneo';
                     break;
                  case 'PD':
                     tipoOperazione = 'Carico da produzione in D';
                     break;
                  case 'PR':
                     tipoOperazione = 'Carico da produzione in R';
                     break;
                  case 'TD':
                     tipoOperazione = 'Carico da terzi in D';
                     break;
                  case 'TR':
                     tipoOperazione = 'Carico da terzi in R';
                     break;
                  default:
                     tipoOperazione = 'Scarico';
                     break;
               }

               let registro = registroCarico.concat('-', registroScarico, registroItermediazione, registroTrasporto);

               setTimeout(() => { }, 300);

               produttore = dataRow.produttore_Descrizione_Sede;
               produttore += ' Indirizzo: ' + dataRow.produttore_Indirizzo_Sede + ', ' + dataRow.produttore_Civico_Sede + ' ';
               produttore += dataRow.produttore_Comune_Sede;
               produttore += '(' + dataRow.produttore_SiglaProvincia_Sede + ')';

               let trasportatore = ' - ';

               if (dataRow.trasportatore_Descrizione_Sede) {
                  trasportatore = dataRow.trasportatore_Descrizione_Sede;
                  trasportatore += ' Indirizzo: ' + dataRow.trasportatore_Indirizzo_Sede + ', ' + dataRow.trasportatore_Civico_Sede + ' ';
                  trasportatore += dataRow.trasportatore_Comune_Sede;
                  trasportatore += '(' + dataRow.trasportatore_SiglaProvincia_Sede + ')';

                  let autista = '-';
                  let targaAutomezzo = '-';

                  if (dataRow.autista_Cognome_Nome) {
                     autista = dataRow.autista_Cognome_Nome;
                  }

                  if (dataRow.automezzo_Targa) {
                     targaAutomezzo = dataRow.automezzo_Targa;
                  }

                  trasportatore += '<b> Autista:</b> ' + autista;
                  trasportatore += '<b> Automezzo Tg:</b> ' + targaAutomezzo;
               }

               let destinatario = ' - ';

               if (dataRow.destinatario_Descrizione_Sede) {
                  destinatario = dataRow.destinatario_Descrizione_Sede;
                  destinatario += '<b> Indirizzo: </b>' + dataRow.destinatario_Indirizzo_Sede + ', ' + dataRow.destinatario_Civico_Sede + ' ';
                  destinatario += dataRow.destinatario_Comune_Sede;
                  destinatario += '(' + dataRow.destinatario_SiglaProvincia_Sede + ')';
               }

               let html = '';

               html += '<div class="shadow" >';
               html += '<div  style="border: 1px solid var(--bs-card-border-color);" class="ombra card-body ">';
               html += '<h5 class="card-title"><span class="dx-form-group-caption">Altri dati movimento </span></h5>';

               html += '<div class="row">';

               html += '<div class="col-sm-3 my-2 pe-0 ps-0">';
               html += '<ul class="list-group list-group-flush border-top border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Causale</li>';
               html += '  <li class="list-group-item bg-white border-end">' + idTipoOperazione + '-' + causale + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '<div class="col-sm-2 my-2 ps-0 pe-0" >';
               html += '<ul class="list-group list-group-flush border-top   border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Posizione</li>';
               html += '  <li class="list-group-item bg-white border-end">' + posizione + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '<div class="col-sm-5 my-2 ps-0 pe-0" >';
               html += '<ul class="list-group list-group-flush border-top  border-end  border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Registro</li>';
               html += '  <li class="list-group-item bg-white ">' + registro + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '<div class="col-sm-2 my-2 ps-0" >';
               html += '<ul class="list-group list-group-flush border-top  border-end  border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Operazione</li>';
               html += '  <li class="list-group-item bg-white ">' + tipoOperazione + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '</div>';

               html += '<div class="row">';
               html += '<div class="col-sm-2 pe-0 ps-0">';
               html += '<ul class="list-group list-group-flush border-top border-start border-end  border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item">Produttore</li>';
               html += '  <li class="list-group-item">Trasportatore</li>';
               html += '  <li class="list-group-item">Destinatario</li>';
               html += '</ul>';
               html += ' </div>';
               html += '<div class="col-sm-7 ps-0 pe-0">';
               html += '<ul class="list-group list-group-flush border-top border-end border-bottom">';
               html += '  <li class="list-group-item">' + produttore + '</li>';
               html += '  <li class="list-group-item">' + trasportatore + '</li>';
               html += '  <li class="list-group-item">' + destinatario + '</li>';
               html += '</ul>';
               html += ' </div>';
               html += '<div class="col-sm-3 ps-0">';
               html += '<ul class="list-group list-group-flush  border-top border-end border-bottom">';
               html += '  <li class="list-group-item">' + ' - ' + '</li>';
               html += '  <li class="list-group-item">' + ' - ' + '</li>';
               html += '  <li class="list-group-item">' + ' - ' + '</li>';
               html += '</ul>';
               html += ' </div>';
               html += ' </div>';

               html += '<div class="row">';
               html += '<div class="col-sm-2 my-2 pe-0 ps-0">';
               html += '<ul class="list-group list-group-flush border-start  border-top  border-end  border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item">' + 'Codice: ' + idMovimento + '</li>';
               html += '</ul>';
               html += ' </div>';

               html += ' </div>';

               html += ' </div>';
               html += ' </div>';

               td.innerHTML = html;
            },
         };
      }

      if (e == 'DammiInfoMovimentoGiacenze') {
         return {
            enabled: true, //Mettere a true per rimettere i dettagli come prima
            template: (td, data) => {
               let dataRow = data.data;
               let produttore = ' - ';

               let idTipoOperazione = dataRow.causale_Id_Operazione;
               let causale = dataRow.causale_Descrizione;
               let posizione = dataRow.posizioneRifiuto_Descrizione;
               let registroCarico = dataRow.registro_Descrizione_Carico ? dataRow.registro_Descrizione_Carico : '';
               let registroScarico = dataRow.registro_Descrizione_Scarico ? dataRow.registro_Descrizione_Scarico : '';
               let registroItermediazione = dataRow.registro_Descrizione_Intermediario ? dataRow.registro_Descrizione_Intermediario : '';
               let registroTrasporto = dataRow.registro_Descrizione_Trasporto ? dataRow.registro_Descrizione_Trasporto : '';

               let registro = registroCarico.concat(' ', registroScarico, registroItermediazione, registroTrasporto);

               setTimeout(() => { }, 300);

               produttore = dataRow.produttore_Descrizione_Sede;
               produttore += ' Indirizzo: ' + dataRow.produttore_Indirizzo_Sede + ', ' + dataRow.produttore_Civico_Sede + ' ';
               produttore += dataRow.produttore_Comune_Sede;
               produttore += '(' + dataRow.produttore_SiglaProvincia_Sede + ')';
               produttore = dataRow.produttore_Descrizione_Sede;

               let trasportatore = ' - ';

               if (dataRow.trasportatore_Descrizione_Sede) {
                  trasportatore = dataRow.trasportatore_Descrizione_Sede;
                  trasportatore += ' Indirizzo: ' + dataRow.trasportatore_Indirizzo_Sede + ', ' + dataRow.trasportatore_Civico_Sede + ' ';
                  trasportatore += dataRow.trasportatore_Comune_Sede;
                  trasportatore += '(' + dataRow.trasportatore_SiglaProvincia_Sede + ')';

                  trasportatore += ' Autista: ' + dataRow.autista_Cognome + '-' + dataRow.autista_Nome;
                  trasportatore += ' Automezzo Tg:' + dataRow.automezzo_Targa;

                  trasportatore = dataRow.trasportatore_Descrizione_Sede;
               }

               let destinatario = ' - ';

               if (dataRow.destinatario_Descrizione_Sede) {
                  destinatario = dataRow.destinatario_Descrizione_Sede;
                  destinatario += ' Indirizzo: ' + dataRow.destinatario_Indirizzo_Sede + ', ' + dataRow.destinatario_Civico_Sede + ' ';
                  destinatario += dataRow.destinatario_Comune_Sede;
                  destinatario += '(' + dataRow.destinatario_SiglaProvincia_Sede + ')';
                  destinatario = dataRow.destinatario_Descrizione_Sede;
               }

               let html = '';

               html += '<div class="card bg-transparent" >';
               html += '<div class="card-body ">';
               html += '<h5 class="card-title"><span class="dx-form-group-caption">Altri dati movimento</span></h5>';

               html += '<div class="row">';
               html += '<div class="col-sm-1 my-2 pe-0">';
               html += '<ul class="list-group list-group-flush border-top border-start border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Tipo operazione</li>';
               html += '  <li class="list-group-item bg-white border-end">' + idTipoOperazione + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '<div class="col-sm-2 my-2 pe-0 ps-0">';
               html += '<ul class="list-group list-group-flush border-top border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Causale</li>';
               html += '  <li class="list-group-item bg-white border-end">' + causale + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '<div class="col-sm-4 my-2 ps-0 pe-0" >';
               html += '<ul class="list-group list-group-flush border-top   border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Posizione</li>';
               html += '  <li class="list-group-item bg-white border-end">' + posizione + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '<div class="col-sm-5 my-2 ps-0" >';
               html += '<ul class="list-group list-group-flush border-top  border-end  border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item header">Registro</li>';
               html += '  <li class="list-group-item bg-white ">' + registro + '</li>';
               html += '</ul>';
               html += '</div>';
               html += '</div>';

               html += '<div class="row">';
               html += '<div class="col-sm-2 pe-0">';
               html += '<ul class="list-group list-group-flush border-top border-start border-end  border-bottom bg-light.bg-gradient">';
               html += '  <li class="list-group-item">Produttore</li>';
               html += '  <li class="list-group-item">Trasportatore</li>';
               html += '  <li class="list-group-item">Destinatario</li>';
               html += '</ul>';
               html += ' </div>';
               html += '<div class="col-sm-10 ps-0">';
               html += '<ul class="list-group list-group-flush border-top border-end border-bottom">';
               html += '  <li class="list-group-item">' + produttore + '</li>';
               html += '  <li class="list-group-item">' + trasportatore + '</li>';
               html += '  <li class="list-group-item">' + destinatario + '</li>';
               html += '</ul>';
               html += ' </div>';
               html += ' </div>';
               html += ' </div>';
               html += ' </div>';

               td.innerHTML = html;
            },
         };
      }
   }
   getService(e: string) {
      switch (e) {
         case 'generaConfigurazione':
            return generaConfigurazione;
         case 'generaGruppo':
            return generaGruppo;
         case 'campoSemplice':
            return campoSemplice;
         case 'campoDynamic':
            return campoDynamic;
         case 'campoCodiceDesc':
            return campoCodiceDesc;
         case 'campoLista':
            return campoLista;
         case 'campoListaM':
            return campoListaM;
         case 'campoButton':
            return campoButton;
         case 'utenti':
            return utenti;
         case 'utentiDiOwner':
            return utentiDiOwner;
         case 'AccountNoAuth':
            return AccountNoAuth;
         case 'login':
            return utenti;
         case 'produttori':
            return produttori;
         case 'trasportatori':
            return trasportatori;
         case 'unitalocali':
            return unitalocali;
         case 'automezzi':
            return automezzi;
         case 'smaltitori':
            return smaltitori;
         case 'crmBancheGrid':
            return crmBancheGrid;
         case 'crmBancheForm':
            return crmBancheForm;
         case 'crmContattiSedeGrid':
            return crmContattiSedeGrid;
         case 'crmContattiSedeForm':
            return crmContattiSedeForm;
         case 'CrmProcedureDetail':
            return CrmProcedureDetail
         case 'CrmProcedureMasterDetail':
            return CrmProcedureMasterDetail
         case 'rentriRegistriElaboratigrid':
            return rentriRegistriElaboratigrid
         case 'accettaModuli':
            return accettaModuli
         case 'CrmProcedureDetailForm':
            return CrmProcedureDetailForm
         case 'CrmProcedureMasterDetailForm':
            return CrmProcedureMasterDetailForm
         case 'CrmContattoExtra':
            return CrmContattoExtra
         case 'crmProcedureGrid':
            return crmProcedureGrid;
         case 'crmProcedureForm':
            return crmProcedureForm;
         case 'crmProcedureModificaPrezzi':
            return crmProcedureModificaPrezzi;
         case 'crmExportMailForm':
            return crmExportMailForm;
         case 'crmStampaContrattoForm':
            return crmStampaContrattoForm;
         case 'crmInviaContrattoForm':
            return crmInviaContrattoForm;
         case 'CrmSendMessaggeForm':
            return CrmSendMessaggeForm;
         case 'comune':
            return comuni;
         case 'cer':
            return cer;
         case 'provincia':
            return provincia;
         case 'soggetto':
            return soggetto;
         case 'statisticheRifiuti':
            return statisticheRifiuti;
         case 'sede':
            return sedeForm;
         case 'soggettoDetail':
            return soggettoDetail;
         case 'formularioForm':
            return formularioForm;
         case 'StatoEstero':
            return StatoEstero;
         case 'Ateco':
            return ateco;
         case 'posizioniRifiuto':
            return posizioniRifiuto;
         case 'categoria':
            return categoria;
         case 'autista':
            return autista;
         case 'SelezioneNsAzienda':
            return SelezioneNsAzienda;
         case 'autorizzazione':
            return autorizzazione;
         case 'TipoAutorizzazione':
            return tipoAutorizzazione;
         case 'formulariFormDatiTrasportoQuantita':
            return formulariFormDatiTrasportoQuantita;
         case 'formulariFormDatiTrasporto':
            return formulariFormDatiTrasporto;
         case 'formulariFormDatiAccettazione':
            return formulariFormDatiAccettazione;
         case 'formulariFormDatiQuantita':
            return formulariFormDatiQuantita;
         case 'infoImpresa':
            return infoImpresa;
         case 'Contatto':
            return contatto;
         case 'zona':
            return zona;
         case 'tipo':
            return tipo;
         case 'onu':
            return onu;
         case 'ateco':
            return ateco;
         case 'magazzinorifiuti':
            return magazzinoRifiuti;
         case 'magazzinorifiuticer':
            return magazzinorifiuticer;
         case 'licenze':
            return licenze;
         case 'Azienda':
            return Azienda;
         case 'CausaleRifiutiBho':
            return CausaleRifiutiBho;
         case 'cantiere':
            return cantiere;
         case 'lotto':
            return lotto;
         case 'albo':
            return albo;
         case 'AlboCategoria':
            return AlboCategoria;
         case 'AlboCer':
            return AlboCer;
         case 'AlboCarrozzeriaMobile':
            return CarrMobili;
         case 'AlboCarrozzeriaMobileCer':
            return CarrCer;
         case 'autorizzazionearea':
            return AutorizzazioneArea2;
         case 'autorizzazioneareacer':
            return AutorizzazioneAreaCer;
         case 'AutorizzazioneAreaCer2':
            return AutorizzazioneAreaCer2;
         case 'autorizzazionecer':
            return AutorizzazioneCer;
         case 'automezzo':
            return automezzo;
         case 'AlboAutomezzo':
            return AlboAutomezzo;
         case 'AlboAutomezzoCer':
            return CarrCer;
         case 'listaCer':
            return listaCer;
         case 'registroRifiuti':
            return RegistroRifiuti;
         case 'CausaliRifiuti':
            return CausaleRifiuti;
         case 'CausaliAvanzate':
            return CausaliAvanzate;
         case 'CausaleRifiutiVociObbligatori':
            return CausaleRifiutiVociObbligatori;
         case 'ConfigurazioniModuli':
            return ConfigurazioniModuli;
         case 'allegatiForm':
            return allegatiForm;
         case 'allegatiGriglia':
            return allegatiGriglia;
         case 'tagAllegati':
            return tagAllegati;
         case 'modelliStampa':
            return modelliStampa;
         case 'ConfigurazioniModuloViviFir':
            return ConfigurazioniModuli;
         case 'ConfigurazioniModuloRentri':
            return ConfigurazioniModuli;
         case 'Configurazioni':
            return Configurazioni;
         case 'NewConfigurazioniModuli':
            return NewConfigurazioniModuli;
         case 'PosizioneCausale':
            return PosizioneCausale;
         case 'ConfigurazionePosizioneCausaleRentri':
            return ConfigurazionePosizioneCausaleRentri;
         case 'ViviFirElencoFIRBlocchi':
            return ViviFirElencoFIRBlocchi;
         case 'VivifirBlocchi':
            return VivifirBlocchi;
         case 'VivifirxFIRBlocchi':
            return VivifirxFIRBlocchi;
         case 'ViviFirBlocchiAzienda':
            return ViviFirBlocchiAzienda;
         case 'ViviFirEditorFir':
            return ViviFirEditorFir;
         case 'ElencoFIRPerBlocco':
            return ElencoFIRPerBlocco;
         case 'ConfigurazioneRentri':
            return ConfigurazioneRentri;
         case 'serviceRentriSede':
            return serviceRentriSede;
         case 'renEsportazioni':
            return renEsportazioni;
         case 'serviceRentriRegistriElenco':
            return serviceRentriRegistriElenco;
         case 'statisticheRifiutiGrafiche':
            return statisticheRifiutiGrafiche;
         case 'graficoCommento':
            return graficoCommento;
         case 'messaggioSemplice':
            return messaggioSemplice;
         case 'gestioneAzienda':
            return gestioneAzienda;
         case 'gestioneAziendaAdmin':
            return gestioneAziendaAdmin;
         case 'esportaForm':
            return esportaForm;
         case 'AccountPermessi':
            return AccountPermessi;
         case 'EsportazioneRentriRegistriGrid':
            return esportazioneRentriRegistriGrid;
         case 'movimentiRifiuto':
            return movimentiRifiuto;
         case 'altriDatiRifiuto':
            return altriDatiRifiuto;
         case 'altriDatiFormulario':
            return altriDatiFormulario;
         case 'rettifica':
            return rettifica;
         case 'altriDatiPesata':
            return altriDatiPesata;
         case 'scaricoRifiuto':
            return scaricoRifiuto;
         case 'elencocarichiAbbinati':
            return elencocarichiAbbinati;
         case 'tabellaScarichi':
            return tabellaScarichi;
         case 'movimentiRifiutoRegistri':
            return movimentiRifiutoRegistri;
         case 'movimentiRifiutoProtocollati':
            return movimentiRifiutoProtocollati;
         case 'listaSoggetti':
            return listaSoggetti;
         case 'giacenzePanelMovimenti':
            return giacenzePanelMovimenti;
         case 'Gruppo':
            return Gruppo;
         case 'EditGruppo':
            return EditGruppo;
         case 'generic':
            return generic;
         case 'SchedaRifiuto':
            return SchedaRifiutoN;
         case 'CrmContattiGrid':
            return CrmContattiGrid
         case 'StampaRegistriCSGrid':
            return StampaRegistriCSGrid
         case 'CrmContattiForm':
            return CrmContattiForm
         case 'crmAgentiGrid':
            return crmAgentiGrid;
         case 'crmAgentiForm':
            return crmAgentiForm;
         case 'crmSendMessageEditForm':
            return crmSendMessageEditForm;
         case 'SchedaRifiutoLavorazione':
            return SchedaRifiutoLavorazione;
         case 'SchedaRifiutoMiscelazione':
            return SchedaRifiutoMiscelazione;
         case 'imballo':
            return imballo;
         case 'imballo2':
            return imballo2AleAnaColumn;
         case 'datiInGrid':
            return datiInGrid
         case 'cobatCer':
            return CobatCer;
         case 'movimentiRifiutoFiltri':
            return movimentiRifiutoFiltri;
         case 'movimentiRifiutoFiltri2':
            return movimentiRifiutoFiltri2;
         case 'formSalvataggioModello':
            return formSalvataggioModello;
         case 'GiacenzaRifiutiIniziali':
            return GiacenzeIniziali;
         case 'GiacenzeRifiuti':
            return GiacenzeRifiuti;
         case 'graficiGiacenze':
            return graficiGiacenze;
         case 'GiacenzeRifiutiFiltro':
            return GiacenzeRifiutiFiltro;
         case 'GiacenzeInizialiGrid':
            return GiacenzeInizialiGrid;
         case 'DettagliGiacenzeIniziali':
            return DettagliGiacenzeIniziali;
         case 'ListaMovimentiGiacenza':
            return ListaMovimentiGiacenza;
         case 'RitiriGrid':
            return RitiriGrid;
         case 'stampaRegistriFiltri':
            return stampaRegistriFiltri;
         case 'stampaRegistriMovimenti':
            return stampaRegistriMovimenti;
         case 'statisticarifiuti':
            return StatisticaRifiuti;
         case 'caricoGiacenzeDetail':
            return caricoGiacenzeDetail;
         case 'movimentiRifiutiPerStatistica':
            return movimentiRifiutiPerStatistica;
         case 'statisticarifiutidett':
            return StatisticaRifiutiDett;
         case 'grigliaMovimentiRegistro':
            return grigliaMovimentiRegistro;
         case 'emissioneFormulariFiltri':
            return emissioneFormulariFiltri;
         case 'ElaboraStatistica':
            return ElaboraStatistica;
         case 'unitaLocaliFiltri':
            return unitaLocaliFiltri;
         case 'esportaSediFiltri':
            return esportaSediFiltri;
         case 'esportaUnitaLocaliFiltri':
            return esportaUnitaLocaliFiltri;
         case 'creaRegistroRentri':
            return creaRegistroRentri
         case 'strutturaExcel':
            return strutturaExcel;
         case 'soggettiFiltri':
            return soggettiFiltri;
         case 'profiloForm':
            return profiloForm;
         case 'cambioPasswordForm':
            return cambioPasswordForm;
         case 'strutturaExcelGriglia':
            return strutturaExcelGriglia;
         case 'modificaAnteprimaPDF':
            return modificaAnteprimaPDF;
         case 'renEsportazioniMovimenti':
            return renEsportazioniMovimenti;
         case 'gestioneUtenti':
            return gestioneUtenti;
         case 'attivaLicenza':
            return attivaLicenza;
         case 'testoAdr':
            return testoAdr;
         case 'giacenzeMovimentoPanel':
            return giacenzeMovimentoPanel;
         case 'RintraccMiscelazione':
            return RintraccMiscelazione;
         case 'statisticheRifiuti':
            return statisticheRifiuti;
         case 'FormulariDaMov':
            return FormulariDaMov;
         case 'addElencoProduttori':
            return addElencoProduttori;
         case 'addElencoTrasportatori':
            return addElencoTrasportatori;
         case 'addElencoDestinatari':
            return addElencoDestinatari;
         case 'movimentiRifiutiPerStatisticaMensile':
            return movimentiRifiutiPerStatisticaMensile;
         case 'crmElencoRecapitiContattoGrid':
            return crmElencoRecapitiContattoGrid
         case 'crmDiarioAttivitaGrid':
            return crmDiarioAttivitaGrid;
         case 'elencoAttivitaGrid':
            return elencoAttivitaGrid;
         case 'diarioAttivitaDashBoardGrid':
            return diarioAttivitaDashBoardGrid;
         case 'elencoAttivitaForm':
            return elencoAttivitaForm;
         case 'crmTipoProcedureGrid':
            return crmTipoProcedureGrid;
         case 'crmTipoProcedureForm':
            return crmTipoProcedureForm;
         case 'CrmSendMessaggeGrid':
            return crmSendMessaggeGrid;
         case 'CrmFilesGrid':
            return crmFilesGrid
         case 'crmFilesGridEmail':
            return crmFilesGridEmail
         case 'crmEmailInviateGrid':
            return crmEmailInviateGrid
         case 'crmAggiornamentiGrid':
            return crmAggiornamentiGrid
         case 'CrmAggiornamentiFiltri':
            return crmAggiornamentiFiltri
         case 'CrmFilesForm':
            return crmFilesForm
         case 'CrmStatisticheProcedure':
            return CrmStatisticheProcedure
         case 'crmTagContattoStatisticheGrid':
            return crmTagContattoStatisticheGrid
         case 'crmTagContattoCommercialiGrid':
            return crmTagContattoCommercialiGrid
         case 'crmTagTipoContattoGrid':
            return crmTagTipoContattoGrid
         case 'crmTagContattoEconomiciGrid':
            return crmTagContattoEconomiciGrid
         case 'crmTagsGrid':
            return crmTagsGrid
         case 'crmTagsForm':
            return crmTagsForm
         case 'crmComuniGrid':
            return crmComuniGrid
         case 'crmComuniForm':
            return crmComuniForm
         case 'crmElencoRecapitiContattoForm':
            return crmElencoRecapitiContattoForm
         case 'crmDiarioAttivitaContatto':
            return crmDiarioAttivitaContatto
         case 'crmContattoInformazioniGenerali':
            return crmContattoInformazioniGenerali
         case 'consumoRegistriXml':
            return consumoRegistriXml
         case 'configurazioneDatabaseAziendale':
            return configurazioneDatabaseAziendale
         case 'crmEstrattoConto':
            return crmEstrattoConto
         case 'crmCensimento':
            return crmCensimento
         default:
            throw new Error(`Template non trovato: ${e}`);
      }
   }
}
